"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankstatementsTableToJSON = exports.BankstatementsTableFromJSONTyped = exports.BankstatementsTableFromJSON = void 0;
var _1 = require("./");
function BankstatementsTableFromJSON(json) {
    return BankstatementsTableFromJSONTyped(json, false);
}
exports.BankstatementsTableFromJSON = BankstatementsTableFromJSON;
function BankstatementsTableFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'current': (0, _1.AmountFromJSON)(json['current']),
        'delayed': (0, _1.AmountFromJSON)(json['delayed']),
        'minimumPayment': (0, _1.AmountFromJSON)(json['minimumPayment']),
    };
}
exports.BankstatementsTableFromJSONTyped = BankstatementsTableFromJSONTyped;
function BankstatementsTableToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'current': (0, _1.AmountToJSON)(value.current),
        'delayed': (0, _1.AmountToJSON)(value.delayed),
        'minimumPayment': (0, _1.AmountToJSON)(value.minimumPayment),
    };
}
exports.BankstatementsTableToJSON = BankstatementsTableToJSON;
//# sourceMappingURL=BankstatementsTable.js.map